import { addQueryParameterToUrl, getQueryParameter, removeQueryParameterFromUrl } from '@salescore/frontend-common'
import { type Dispatch, useState } from 'react'

// 現時点でこのhookを使っているのはSearchQueryInputのみ。
// もし複数のコンポーネントからこのhookを呼び出す場合、
//  1つのコンポーネントからstateを更新しても、他方のstateを同期する仕組みが実装できていない。
// 複数のコンポーネントで使いたい場合はReduxでの管理を検討する。
export const useSearchQuery = (onUpdate: () => void): [string, Dispatch<string>] => {
  const [searchQuery, setSearchQuery] = useState(getQueryParameter('searchQuery') ?? '')
  const setStateAndUpdateQueryParameter = (searchQuery: string): void => {
    setSearchQuery(searchQuery)
    if (searchQuery === '') {
      removeQueryParameterFromUrl('searchQuery')
    } else {
      addQueryParameterToUrl('searchQuery', searchQuery)
    }
    onUpdate()
  }

  return [searchQuery, setStateAndUpdateQueryParameter]
}
